import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./product-useCases.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { CasesService } from "../../../../../../services/cases/cases.service";
import { DataTableComponent } from "../../../../../../components/table/data-table/data-table.component";
import { productUseCasesColumns } from "../../../../../../statics/table-columns/product-useCases";
import { defaultItems } from "../../../../../../statics/pagination";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const ProductUseCasesComponent = (props: any) => {
  const { t } = useTranslation();
  const { product, loading } = props;
  const casesService = useMemo(() => new CasesService(), []);
  const [cases, setCases] = useState<any[]>([]);
  const [useCasesLoading, setUseCasesLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<any>({
    items: defaultItems,
    currentPage: 1,
    total: 0,
    totalPages: 0,
  });

  // Fetch use cases by product ID
  const fetchUseCases = useCallback(async () => {
    if (!product?.id) {
      setCases([]);
      setUseCasesLoading(false);
      return;
    }
    try {
      setCases([]);
      setUseCasesLoading(true);
      const params = {
        productId: product.id,
        items: pagination.items,
        page: pagination.currentPage,
      };
      const response = await casesService.list(params);

      if (response && response.data) {
        setCases(response.data || []);
        setPagination({
          currentPage: response.page || 1,
          items: response.per_page || 15,
          totalPages: response.totalPages || 1,
          total: response.total || 0,
        });
      } else {
        setCases([]);
      }
    } catch (error) {
      console.error("Error fetching use cases:", error);
      setCases([]);
    } finally {
      setUseCasesLoading(false);
    }
    // eslint-disable-next-line
  }, [product?.id, casesService, pagination.items, pagination.currentPage]);

  useEffect(() => {
    fetchUseCases();
  }, [fetchUseCases]);

  const paginateTable = useCallback((newPagination: any) => {
    setPagination((prev: any) => ({
      ...prev,
      currentPage: newPagination.currentPage,
      items: newPagination.items,
    }));
    // eslint-disable-next-line
  }, []);

  const sortTable = useCallback((fieldName: string, sortDirection: string) => {
    // Handle sorting if needed
    console.log("Sort:", fieldName, sortDirection);
    // eslint-disable-next-line
  }, []);

  const options = useMemo(
    () => ({
      withSort: true,
      sortDirection: "asc",
      sortColumn: "",
    }),
    [],
  );

  return (
    <Box className="product__use_cases">
      <Box className="title mb-4">
        {loading ? (
          <Skeleton variant="text" height={20} width={200} />
        ) : (
          <Typography
            variant="h2"
            color="textPrimary"
            className="text-capitalize"
          >
            {t("PRODUCTS_PAGE.RELATED_USE_CASES")}
          </Typography>
        )}
        {loading ? (
          <Skeleton variant="text" height={18} width={180} />
        ) : (
          <Typography variant="subtitle1" color="textSecondary">
            {t(
              "PRODUCTS_PAGE.HERE_YOU_CAN_SEE_ALL_RELATET_AI_USE_CASES_OF_THIS_PRODUCTS",
            )}
          </Typography>
        )}
      </Box>
      <Box className="table-section">
        <DataTableComponent
          tableName="productUseCases"
          loading={useCasesLoading}
          columns={productUseCasesColumns}
          data={cases}
          options={options}
          sort={sortTable}
          pagination={pagination}
          paginate={paginateTable}
          clickableRow={["case", "id"]}
          title={t("PRODUCTS_PAGE.LIST_OF_RELATED_USE_CASES")}
        />
      </Box>
    </Box>
  );
};

export default ProductUseCasesComponent;
